export const UserDate = [
  {
    id: 1,
    yaer: '1401/08/25',
    userGain: 52,
    userLost: 823
  },
  {
    id: 2,
    yaer: '1401/08/26',
    userGain: 31,
    userLost: 345
  },
  {
    id: 3,
    yaer: '1401/08/27',
    userGain: 39,
    userLost: 555
  },
  {
    id: 4,
    yaer: '1401/08/28',
    userGain: 54,
    userLost: 485
  },
  {
    id: 5,
    yaer: '1401/08/29',
    userGain: 54,
    userLost: 485
  },
  {
    id: 6,
    yaer: '1401/08/30',
    userGain: 20,
    userLost: 485
  },
  {
    id: 7,
    yaer: '1401/09/01',
    userGain: 25,
    userLost: 432
  }
]

export const UserDate2 = [
  {
    id: 1,
    yaer: '1401/08/25',
    userGain: 30,
    userLost: 562
  },
  {
    id: 2,
    yaer: '1401/08/26',
    userGain: 70,
    userLost: 851
  },
  {
    id: 3,
    yaer: '1401/08/27',
    userGain: 62,
    userLost: 358
  },
  {
    id: 4,
    yaer: '1401/08/28',
    userGain: 32,
    userLost: 100
  },
  {
    id: 5,
    yaer: '1401/08/29',
    userGain: 70,
    userLost: 36
  },
  {
    id: 6,
    yaer: '1401/08/30',
    userGain: 20,
    userLost: 485
  },
  {
    id: 7,
    yaer: '1401/09/01',
    userGain: 23,
    userLost: 485
  }
]

export const baseUrl = { address : '' }